enum OrderStatusEnum {
  client_received = 'client_received',
  done = 'done',
  reserving = 'reserving',
  fitting_available = 'fitting_available',
  in_transit = 'in_transit',
  not_delivered = 'not_delivered',
  partially_shipped = 'partially_shipped',
  client_rejected = 'client_rejected',
  reserved = 'reserved',
  completing = 'completing',
  completed = 'completed',
  shipping = 'shipping',
  shipping_problem = 'shipping_problem',
  awaiting_re_delivery = 'awaiting_re-delivery',

  accepted = 'accepted',
  performed = 'performed',
  shipped = 'shipped',
  shipped_to_store = 'shipped_to_store',
  waited = 'waited',
  cancelled = 'cancelled',
  worked = 'worked',
  prepared = 'prepared',
  ready_to_issue = 'ready_to_issue',
  at_pickup = 'at_pickup',
  waiting_delivery = 'waiting_delivery',
  waiting_assembly = 'waiting_assembly',
  in_work = 'in_work',

  ord_full_delivered = 'ord_full_delivered',
  ord_partially_delivered = 'ord_partially_delivered',
  arrived_to_transit_whs_cc = 'arrived_to_transit_whs_cc',
  courier_search = 'courier_search',
  cancelled_by_courier = 'cancelled_by_courier',
  courier_not_found = 'courier_not_found',
  ord_sent_to_cc = 'ord_sent_to_cc',
  ord_accepted_to_cc = 'ord_accepted_to_cc',
  ord_sent_to_delivery_region = 'ord_sent_to_delivery_region',
  arrived_to_region_and_awaiting_delivery = 'arrived_to_region_and_awaiting_delivery',
  transfered_for_delivery = 'transfered_for_delivery',
  returned_to_whs_cc = 'returned_to_whs_cc',
  courier_called = 'courier_called',
  ready_for_delivery = 'ready_for_delivery',
  ord_canceled_by_sm = 'ord_canceled_by_sm',
  ord_storage_period_expired = 'ord_storage_period_expired',
  client_refusal = 'client_refusal',
  ord_canceled = 'ord_canceled',
}
enum ReceivingMethodsEnum {
  PICKUP = 'pickup',
  THIRDPARTY = 'thirdparty',
  POST = 'post',
  DELIVERY = 'delivery',
  GIFT_CARD = 'gift_card',
}

export class OstinOrderStatusMapper {
  mapToEntity({ shippingGroupType, withDelivery, status }): OrderStatusEnum {
    return this.mapStatus(shippingGroupType, withDelivery, status);
  }

  private mapStatus(shippingGroupType: string, withDelivery: string, status: OrderStatusEnum): OrderStatusEnum {
    const additionalStatus: OrderStatusEnum | null = this.mapNoConditions(status);
    if (additionalStatus) {
      return additionalStatus;
    }

    if (shippingGroupType === ReceivingMethodsEnum.POST || shippingGroupType === ReceivingMethodsEnum.THIRDPARTY) {
      return this.mapToThirdpartyPost(status);
    }

    if (shippingGroupType === ReceivingMethodsEnum.DELIVERY) {
      return this.mapToDelivery(status);
    }

    if (shippingGroupType === ReceivingMethodsEnum.PICKUP && !withDelivery) {
      return this.mapToPickupWithoutDelivery(status);
    }

    if (shippingGroupType === ReceivingMethodsEnum.PICKUP && withDelivery) {
      return this.mapToPickupWithDelivery(status);
    }

    return status;
  }

  private mapNoConditions(status: OrderStatusEnum): OrderStatusEnum | null {
    const mapStatus = new Map<string, OrderStatusEnum>([
      [OrderStatusEnum.ord_full_delivered, OrderStatusEnum.performed],
      [OrderStatusEnum.ord_partially_delivered, OrderStatusEnum.performed],

      [OrderStatusEnum.arrived_to_transit_whs_cc, OrderStatusEnum.shipped],
      [OrderStatusEnum.courier_search, OrderStatusEnum.shipped],
      [OrderStatusEnum.cancelled_by_courier, OrderStatusEnum.shipped],
      [OrderStatusEnum.courier_not_found, OrderStatusEnum.shipped],
      [OrderStatusEnum.ord_sent_to_cc, OrderStatusEnum.shipped],
      [OrderStatusEnum.ord_accepted_to_cc, OrderStatusEnum.shipped],
      [OrderStatusEnum.ord_sent_to_delivery_region, OrderStatusEnum.shipped],
      [OrderStatusEnum.arrived_to_region_and_awaiting_delivery, OrderStatusEnum.shipped],
      [OrderStatusEnum.transfered_for_delivery, OrderStatusEnum.shipped],
      [OrderStatusEnum.returned_to_whs_cc, OrderStatusEnum.shipped],
      [OrderStatusEnum.courier_called, OrderStatusEnum.shipped],
      [OrderStatusEnum.ready_for_delivery, OrderStatusEnum.shipped],

      [OrderStatusEnum.ord_canceled_by_sm, OrderStatusEnum.cancelled],
      [OrderStatusEnum.ord_storage_period_expired, OrderStatusEnum.cancelled],
      [OrderStatusEnum.client_refusal, OrderStatusEnum.cancelled],
      [OrderStatusEnum.ord_canceled, OrderStatusEnum.cancelled],
    ]);

    return mapStatus.get(status) ?? null;
  }

  private mapToThirdpartyPost(status: OrderStatusEnum): OrderStatusEnum {
    const mapStatus = new Map([
      [OrderStatusEnum.accepted, OrderStatusEnum.accepted],
      [OrderStatusEnum.reserving, OrderStatusEnum.accepted],

      [OrderStatusEnum.client_received, OrderStatusEnum.performed],
      [OrderStatusEnum.done, OrderStatusEnum.performed],

      [OrderStatusEnum.in_transit, OrderStatusEnum.shipped],
      [OrderStatusEnum.partially_shipped, OrderStatusEnum.shipped],

      [OrderStatusEnum.client_rejected, OrderStatusEnum.cancelled],
      [OrderStatusEnum.cancelled, OrderStatusEnum.cancelled],

      [OrderStatusEnum.at_pickup, OrderStatusEnum.at_pickup],

      [OrderStatusEnum.reserved, OrderStatusEnum.waiting_assembly],
      [OrderStatusEnum.completing, OrderStatusEnum.waiting_assembly],
      [OrderStatusEnum.completed, OrderStatusEnum.waiting_assembly],

      [OrderStatusEnum.shipping, OrderStatusEnum.in_work],
      [OrderStatusEnum.shipping_problem, OrderStatusEnum.in_work],

    ]);
    return mapStatus.get(status) ?? status;
  }

  private mapToDelivery(status: OrderStatusEnum): OrderStatusEnum {
    const mapStatus = new Map([
      [OrderStatusEnum.accepted, OrderStatusEnum.accepted],
      [OrderStatusEnum.reserving, OrderStatusEnum.accepted],

      [OrderStatusEnum.client_received, OrderStatusEnum.performed],
      [OrderStatusEnum.done, OrderStatusEnum.performed],

      [OrderStatusEnum.not_delivered, OrderStatusEnum.shipped],
      [OrderStatusEnum.in_transit, OrderStatusEnum.shipped],
      [OrderStatusEnum.partially_shipped, OrderStatusEnum.shipped],

      [OrderStatusEnum.awaiting_re_delivery, OrderStatusEnum.prepared],

      [OrderStatusEnum.client_rejected, OrderStatusEnum.cancelled],
      [OrderStatusEnum.cancelled, OrderStatusEnum.cancelled],

      [OrderStatusEnum.reserved, OrderStatusEnum.waiting_assembly],
      [OrderStatusEnum.completing, OrderStatusEnum.waiting_assembly],
      [OrderStatusEnum.completed, OrderStatusEnum.waiting_assembly],

      [OrderStatusEnum.shipping, OrderStatusEnum.in_work],
      [OrderStatusEnum.shipping_problem, OrderStatusEnum.in_work],

    ]);
    return mapStatus.get(status) ?? status;
  }

  private mapToPickupWithoutDelivery(status: OrderStatusEnum): OrderStatusEnum {
    const mapStatus = new Map([
      [OrderStatusEnum.accepted, OrderStatusEnum.accepted],
      [OrderStatusEnum.reserving, OrderStatusEnum.accepted],

      [OrderStatusEnum.client_received, OrderStatusEnum.performed],
      [OrderStatusEnum.done, OrderStatusEnum.performed],

      [OrderStatusEnum.completed, OrderStatusEnum.ready_to_issue],
      [OrderStatusEnum.fitting_available, OrderStatusEnum.ready_to_issue],

      [OrderStatusEnum.client_rejected, OrderStatusEnum.cancelled],
      [OrderStatusEnum.cancelled, OrderStatusEnum.cancelled],

      [OrderStatusEnum.reserved, OrderStatusEnum.waiting_assembly],
      [OrderStatusEnum.completing, OrderStatusEnum.waiting_assembly],

    ]);
    return mapStatus.get(status) ?? status;
  }

  private mapToPickupWithDelivery(status: OrderStatusEnum): OrderStatusEnum {
    const mapStatus = new Map([
      [OrderStatusEnum.accepted, OrderStatusEnum.accepted],
      [OrderStatusEnum.reserving, OrderStatusEnum.accepted],

      [OrderStatusEnum.client_received, OrderStatusEnum.performed],
      [OrderStatusEnum.done, OrderStatusEnum.performed],

      [OrderStatusEnum.completing, OrderStatusEnum.shipped_to_store],

      [OrderStatusEnum.completed, OrderStatusEnum.ready_to_issue],
      [OrderStatusEnum.fitting_available, OrderStatusEnum.ready_to_issue],

      [OrderStatusEnum.client_rejected, OrderStatusEnum.cancelled],
      [OrderStatusEnum.cancelled, OrderStatusEnum.cancelled],

      [OrderStatusEnum.reserved, OrderStatusEnum.waiting_assembly],

    ]);
    return mapStatus.get(status) ?? status;
  }
}
